<template>
  <div class="payment">
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title> Application Fee </v-card-title>
          <v-card-subtitle class="subtitle">
            Application Fee: ${{ amount }}.00
            <span>(USD / applicant)</span>
            <br />
            Paying For:
          </v-card-subtitle>
          <v-divider />
          <v-card-text>
            <b>Total Due: ${{ amount }}.00 (USD)</b>
            <br />
            <br />
            <div class="content">
              By Clicking the Submit and Pay Button you understand that: <br />
              <ul>
                <li>
                  A one time charge will appear on your statement as Alpine
                  Leasing, LLC.
                </li>
                <li>
                  <b
                    >Application fees are non-refundable even if you are not
                    accepted for tenancy</b
                  >
                </li>
                <li>
                  I understand that the application is not submitted until
                  payment has been completed
                </li>
              </ul>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-form ref="form" v-model="form">
          <v-row>
            <v-col cols="12" md="12">
              <div class="title mb-5 mt-5">Payment Information</div>
            </v-col>
            <v-col cols="12">
              <v-text-field
                placeholder="Email"
                v-model="email"
                :rules="emailRules"
                outlined
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <form method="post" id="payment-form" class="clover">
          <v-row>
            <v-col cols="12" md="12">
              <div class="form-row">
                <div id="card-name" class="field card-name"></div>
                <div
                  class="input-errors"
                  id="card-name-errors"
                  role="alert"
                ></div>
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <div class="form-row">
                <div id="card-number" class="field card-number"></div>
                <div
                  class="input-errors"
                  id="card-number-errors"
                  role="alert"
                ></div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="form-row">
                <div id="card-date" class="field third-width"></div>
                <div
                  class="input-errors"
                  id="card-date-errors"
                  role="alert"
                ></div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="form-row">
                <div id="card-cvv" class="field third-width"></div>
                <div
                  class="input-errors"
                  id="card-cvv-errors"
                  role="alert"
                ></div>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="form-row">
                <div id="card-postal-code" class="field third-width"></div>
                <div
                  class="input-errors"
                  id="card-postal-code-errors"
                  role="alert"
                ></div>
              </div>
            </v-col>
            <v-col cols="12" md="12" class="mt-7">
              <v-btn @click="$emit('step', 5)" class="mr-5" color="primary"
                >Back</v-btn
              >
              <v-btn color="success" @click="charge()">Submit and Pay</v-btn>
            </v-col>
          </v-row>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/*
// eslint-disable-next-line no-undef Test
let clover = new Clover("71c40be95f02ef1c036c198a9308700a", {
  merchantId: "2SJJ3PWD0W7QM",
});

*/

// eslint-disable-next-line no-undef
let clover = new Clover("f473f49228bd29c1b93666b1ea5e9df7");
const elements = clover.elements();
import { functions, db } from "../assets/js/firebase";
export default {
  data() {
    return {
      stripe: null,
      amount: "",
      name: "",
      email: "",
      form: false,
      card: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      rules: [(v) => !!v || "Name is required"],
    };
  },
  methods: {
    async getCharge() {
      try {
        this.amount = (await db.child("charge").once("value")).val();
        console.log("amount", this.amount);
      } catch (error) {
        console.log("Error while fetching amount", error.message);
      }
    },
    async charge() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.form) return;
      vm.$root.loader = true;
      clover.createToken().then(function(result) {
        if (result.errors) {
          vm.$root.loader = false;
          vm.handleCloverError(result.errors);
        } else {
          let form = {};
          form.token = result.token;
          form.email = vm.email;
          form.form = vm.$store.getters.form;
          vm.send(form);
        }
      });
    },
    handleCloverError(error) {
      const displayCardNumberError = document.getElementById(
        "card-number-errors"
      );
      const displayCardDateError = document.getElementById("card-date-errors");
      const displayCardCvvError = document.getElementById("card-cvv-errors");
      const displayCardPostalCodeError = document.getElementById(
        "card-postal-code-errors"
      );
      if (error.CARD_CVV) {
        displayCardCvvError.innerText = error.CARD_CVV;
      } else {
        displayCardCvvError.innerText = "";
      }
      if (error.CARD_DATE) {
        displayCardDateError.innerText = error.CARD_DATE;
      } else {
        displayCardDateError.innerText = "";
      }
      if (error.CARD_NUMBER) {
        displayCardNumberError.innerText = error.CARD_NUMBER;
      } else {
        displayCardNumberError.innerText = "";
      }
      if (error.CARD_POSTAL_CODE) {
        displayCardPostalCodeError.innerText = error.CARD_POSTAL_CODE;
      } else {
        displayCardPostalCodeError.innerText = "";
      }
    },
    send(data) {
      var charge = functions.httpsCallable("cloverCharge");
      const vm = this;
      charge(data)
        .then(function(result) {
          vm.$root.loader = false;
          let { message, status, docId } = result.data;
          if (status) {
            vm.$router.replace("/documents/" + docId + "/success");
          } else {
            vm.$root.alert(message);
          }
        })
        .catch(({ message }) => {
          vm.$root.loader = false;
          vm.$root.alert(message);
        });
    },
    initClover() {
      // const form = document.getElementById("payment-form");
      let styles = {};
      const cardNumber = elements.create("CARD_NUMBER", styles);
      const cardDate = elements.create("CARD_DATE", styles);
      const cardCvv = elements.create("CARD_CVV", styles);
      const cardPostalCode = elements.create("CARD_POSTAL_CODE", styles);
      const cardHolderName = elements.create("CARD_NAME", styles);

      cardHolderName.mount("#card-name");
      cardNumber.mount("#card-number");
      cardDate.mount("#card-date");
      cardCvv.mount("#card-cvv");
      cardPostalCode.mount("#card-postal-code");
      const displayCardNumberError = document.getElementById(
        "card-number-errors"
      );
      const displayCardNameError = document.getElementById("card-name-errors");
      const displayCardDateError = document.getElementById("card-date-errors");
      const displayCardCvvError = document.getElementById("card-cvv-errors");
      const displayCardPostalCodeError = document.getElementById(
        "card-postal-code-errors"
      );

      // Handle real-time validation errors from the card element
      cardNumber.addEventListener("change", function(event) {
        if (event.CARD_NUMBER.error) {
          displayCardNumberError.innerText = event.CARD_NUMBER.error;
        } else {
          displayCardNumberError.innerText = "";
        }
      });
      cardHolderName.addEventListener("change", function(event) {
        console.log(event);
        if (event.CARD_NAME.error) {
          displayCardNameError.innerText = event.CARD_NAME.error;
        } else {
          displayCardNameError.innerText = "";
        }
      });

      cardDate.addEventListener("change", function(event) {
        if (event.CARD_DATE.error) {
          displayCardDateError.innerText = event.CARD_DATE.error;
        } else {
          displayCardDateError.innerText = "";
        }
      });

      cardCvv.addEventListener("change", function(event) {
        if (event.CARD_CVV.error) {
          displayCardCvvError.innerText = event.CARD_CVV.error;
        } else {
          displayCardCvvError.innerText = "";
        }
      });

      cardPostalCode.addEventListener("change", function(event) {
        if (event.CARD_POSTAL_CODE.error) {
          displayCardPostalCodeError.innerText = event.CARD_POSTAL_CODE.error;
        } else {
          displayCardPostalCodeError.innerText = "";
        }
      });
    },
  },
  async mounted() {
    const vm = this;
    vm.getCharge();
    vm.initClover();
  },
};
</script>

<style lang="scss">
.StripeElement {
  box-sizing: border-box;

  height: 56px;
  padding: 18px;
  border: 1px solid gray;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.payment {
  z-index: 100;
}

.clover {
  .input-errors {
    font-size: 12px;
    position: absolute;
    margin-left: 5px;
    color: red;
  }

  .form-row .field {
    box-sizing: border-box;
    border: 2px solid lightgrey;
    border-radius: 5px;
    height: 50px;
    padding: 14px;
    width: 100%;
  }
}
</style>
